import Image from "assets/404.jpg"
import { Button } from "components/button"
import { ButtonVariant } from "components/button/types"
import { useNavigate } from "react-router-dom"
import { ROUTES } from "routes"

export default function NotFound() {
	const navigate = useNavigate()

	return (
		<div className="flex flex-col items-center justify-center w-full h-[100vh]">
			<img src={Image} width={347} height={305} className="mb-6" />

			<p className="text-[20px] text-[#3D3D3D] mb-4 font-semibold">
				Documento não encontrado
			</p>
			<p className="text-[16px] text-[#6D6D6D] mb-6 max-w-[380px] text-center">
				O documento que você está tentando acessar não existe ou foi
				removido.
			</p>

			<Button
				variant={ButtonVariant.Contained}
				className="w-fit"
				onClick={() => navigate(ROUTES.basePage())}
			>
				Voltar à tela inicial
			</Button>
		</div>
	)
}
